<template>
    <div>
        <label>{{ partnerName }} <span>{{ partnerType }}</span></label>
        <star-rating :rating-range="RatingRange" />
        <span class="review-count">({{ ReviewCount }})</span>
        <div class="clear-fix"></div>
        <a v-if="ReviewDetailsUrl" :href="ReviewDetailsUrl" class="read-review" target="_blank">Read Reviews & Details</a>
    </div>
</template>
<script>
    import { find } from 'lodash-es';
    import StarRating from './star-rating.vue';

    export default {
        props: {
            partnerName: {
                default: '',
            },
            lenderId: {
                default: '',
            },
            partnerType: {
                default: '',
            },
            lenderReviewRatingDetails: {
                default() {
                    return [];
                },
            },
        },
        data() {
            return {
                LenderId: this.lenderId,
            };
        },
        computed: {
            LenderReviewRating() {
                return this.lenderReviewRatingDetails && this.lenderReviewRatingDetails.length > 0 ? find(this.lenderReviewRatingDetails, lender => lender.key === this.lenderId) : this.lenderReviewRatingDetails;
            },
            ReviewCount() {
                return this.LenderReviewRating !== undefined && this.LenderReviewRating.value && this.LenderReviewRating.value.length > 1 ? this.LenderReviewRating.value[1].ReviewCount : '0';
            },
            RatingRange() {
                return this.LenderReviewRating && this.LenderReviewRating.value && this.LenderReviewRating.value.length > 2 ? this.LenderReviewRating.value[2].RatingRange : '0';
            },
            ReviewDetailsUrl() {
                return this.LenderReviewRating && this.LenderReviewRating.value && this.LenderReviewRating.value.length > 0 ? this.LenderReviewRating.value[0].ReviewDetailsUrl : '';
            },
        },
        components: {
            StarRating,
        },
    };
</script>
